<form [formGroup]="form" class="row">
	<mat-form-field appearance="fill">
		<mat-label>Data Year</mat-label>
		<mat-select formControlName="year">
			<mat-option *ngFor="let year of years" [value]="year">{{ year }}</mat-option>
		</mat-select>
		<mat-hint>Season / Playing Year etc.</mat-hint>
	</mat-form-field>
</form>
